import React from "react";
import {useTranslation} from "react-i18next";
import SpaceBetween from "@awsui/components-react/space-between";
import Container from "@awsui/components-react/container";
import Header from "@awsui/components-react/header";
import Competition from "model/Competition";
import Tabs from "@awsui/components-react/tabs";
import AllLineupsComponent from "pages/standings/components/AllLineupsComponent";
import AllAnswersComponent from "pages/standings/components/AllAnswersComponent";
import {CompetitionState} from "model/CompetitionState";


interface AllResultsProps {
    competition: Competition;
}

const AllResults: React.FC<AllResultsProps> = (props) => {

    const {t} = useTranslation("standings");
    return props.competition.state !== CompetitionState.NOT_STARTED ? (
        <SpaceBetween size={"l"}>
            <Container
                variant={"default"}
                header={
                    <Header variant={"h2"}>
                        {t("allResultsTitle")}
                    </Header>
                }
            >
                <Tabs
                    tabs={[
                        {
                            label: t("tabs.lineups"),
                            id: "allLineupsTab",
                            content:
                                <AllLineupsComponent competition={props.competition} />
                        },
                        {
                            label: t("tabs.questions"),
                            id: "allQuestionsTab",
                            content:
                                <AllAnswersComponent competition={props.competition} />
                        }
                    ]}
                />
            </Container>
        </SpaceBetween>
    ) : null;
};

export default AllResults;
